import { toDisplayString as _toDisplayString, createVNode as _createVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-489bc54e")

_pushScopeId("data-v-489bc54e")
const _hoisted_1 = { class: "business-invoice-general-data container" }
const _hoisted_2 = { class: "business-invoice-for-to" }
const _hoisted_3 = { class: "business-invoice-for-to-line" }
const _hoisted_4 = {
  class: "pb-1",
  style: {"opacity":"0.8"}
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  class: "invalid-feedback",
  style: {"grid-column":"1 / 3"}
}
const _hoisted_7 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-error fs-16 pr4" }, null, -1)
const _hoisted_8 = {
  key: 1,
  style: {"font-size":"20px"}
}
const _hoisted_9 = { class: "business-invoice-for-to-line" }
const _hoisted_10 = {
  class: "pb-1",
  style: {"opacity":"0.8"}
}
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  class: "invalid-feedback",
  style: {"grid-column":"1 / 3"}
}
const _hoisted_13 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-error fs-16 pr4" }, null, -1)
const _hoisted_14 = {
  key: 1,
  style: {"font-size":"20px"}
}
const _hoisted_15 = { class: "today-date" }
const _hoisted_16 = {
  key: 0,
  class: "today-date"
}
const _hoisted_17 = {
  key: 1,
  class: "today-date"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Calendar = _resolveComponent("Calendar")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('accounting.to')), 1),
        (_ctx.isNew || _ctx.editMode)
          ? (_openBlock(), _createBlock("div", _hoisted_5, [
              _withDirectives(_createVNode("input", {
                class: "bookit-input w-100",
                required: "",
                type: "text",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.recipientName = $event)),
                onKeydown: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.moveToNextInput($event, 'forId')), ["enter"])),
                onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.updateRecipientName && _ctx.updateRecipientName(...args)))
              }, null, 544), [
                [_vModelText, _ctx.recipientName]
              ]),
              _createVNode("span", _hoisted_6, [
                _hoisted_7,
                _createTextVNode(" " + _toDisplayString(_ctx.$t('valid.isRequired')), 1)
              ])
            ]))
          : (_openBlock(), _createBlock("div", _hoisted_8, _toDisplayString(_ctx.recipientName), 1))
      ]),
      _createVNode("div", _hoisted_9, [
        _createVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('accounting.for')), 1),
        (_ctx.isNew || _ctx.editMode)
          ? (_openBlock(), _createBlock("div", _hoisted_11, [
              _withDirectives(_createVNode("input", {
                id: "forId",
                class: "bookit-input w-100",
                required: "",
                type: "text",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.forText = $event)),
                onKeydown: _cache[5] || (_cache[5] = _withKeys(($event: any) => (_ctx.moveToNextInput($event)), ["enter"])),
                onBlur: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.updateFor && _ctx.updateFor(...args)))
              }, null, 544), [
                [_vModelText, _ctx.forText]
              ]),
              _createVNode("span", _hoisted_12, [
                _hoisted_13,
                _createTextVNode(" " + _toDisplayString(_ctx.$t('valid.isRequired')), 1)
              ])
            ]))
          : (_openBlock(), _createBlock("div", _hoisted_14, _toDisplayString(_ctx.forText), 1))
      ])
    ]),
    _createVNode("div", _hoisted_15, [
      _createVNode("div", null, _toDisplayString(_ctx.isNew ? _ctx.$t('label.date') : _ctx.$t('label.created-date')), 1),
      _createVNode("div", null, _toDisplayString(_ctx.createdDate), 1)
    ]),
    (_ctx.isNew && _ctx.isInvoice)
      ? (_openBlock(), _createBlock("div", _hoisted_16, [
          _createVNode("div", null, _toDisplayString(_ctx.$t('label.valueDate')), 1),
          _createVNode("div", null, [
            _createVNode(_component_Calendar, {
              onDateSelect: _ctx.valueDateChanged,
              modelValue: _ctx.issueDateProp,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.issueDateProp = $event)),
              selectionMode: "single",
              dateFormat: "dd/mm/yy"
            }, null, 8, ["onDateSelect", "modelValue"])
          ])
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_17, [
          _createVNode("div", null, _toDisplayString(_ctx.$t('label.valueDate')), 1),
          _createVNode("div", null, _toDisplayString(_ctx.issueDate), 1)
        ]))
  ]))
})